'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _PropertyBag2 = require('../Core/PropertyBag');

var _PropertyBag3 = _interopRequireDefault(_PropertyBag2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Represents a message that is exchanged between an application and a third party
 *
 * @class
 * @extends {PropertyBag}
 */
var WidgetMessage = function (_PropertyBag) {
  (0, _inherits3.default)(WidgetMessage, _PropertyBag);

  function WidgetMessage() {
    (0, _classCallCheck3.default)(this, WidgetMessage);
    return (0, _possibleConstructorReturn3.default)(this, (WidgetMessage.__proto__ || (0, _getPrototypeOf2.default)(WidgetMessage)).apply(this, arguments));
  }

  (0, _createClass3.default)(WidgetMessage, [{
    key: 'id',

    /**
     * The message id
     *
     * @readonly
     *
     * @type {String}
     */
    get: function get() {
      return this.props.id;
    }
  }, {
    key: 'widgetId',


    /**
     * The widget/application id
     * @readonly
     *
     * @type {String}
     */
    get: function get() {
      return this.props.widgetId;
    }
  }, {
    key: 'correlationId',


    /**
     * The conversation id
     *
     * @readonly
     *
     * @type {String}
     */
    get: function get() {
      return this.props.correlationId;
    }
  }, {
    key: 'body',


    /**
     * The message contents
     *
     * @readonly
     *
     * @type {*}
     */
    get: function get() {
      return this.props.body;
    }
  }]);
  return WidgetMessage;
}(_PropertyBag3.default);

exports.default = WidgetMessage;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Widget/WidgetMessage.js
// module id = 156
// module chunks = 0